<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="card-header__name">
          <h3 v-if="mData.viewMode === 'create'">THÊM MỚI GÓI DỊCH VỤ</h3>
          <h3 v-if="mData.viewMode === 'detail'">
            CHI TIẾT GÓI DỊCH VỤ <span>{{ mData.dataForm.ten }}</span>
          </h3>
          <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT GÓI DỊCH VỤ</h3>
        </div>
      </div>

      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-position="left"
          label-width="150px"
          class="form-prd-goi-dich-vu"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Tên gói"
                prop="ten"
                class="d-flex"
                v-if="mData.viewMode !== 'detail'"
              >
                <el-input
                  ref="ten"
                  class="w-100"
                  placeholder="Nhập tên gói dịch vụ"
                  v-model="mData.dataForm.ten"
                  @change="trimString"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Mã gói"
                prop="ma"
                class="d-flex"
                v-if="mData.viewMode !== 'detail'"
              >
                <el-input
                  ref="ma"
                  class="w-100"
                  :disabled="mData.viewMode === 'update'"
                  placeholder="Nhập mã gói dịch vụ"
                  v-model="mData.dataForm.ma"
                  @change="trimString"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="d-flex" v-if="mData.viewMode !== 'detail'">
            <el-form-item
              label="Loại chu kỳ gói"
              prop="chu_ky_goi.loai"
              class="d-flex"
            >
              <el-select
                v-model="mData.dataForm.chu_ky_goi.loai"
                placeholder="Chọn loại chu kỳ gói"
                ref="chu_ky_goi.loai"
              >
                <el-option
                  v-for="item in mData.chuKyGoi"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="Giá trị"
              prop="chu_ky_goi.gia_tri"
              class="d-flex ml-5"
            >
              <el-input-number
                ref="chu_ky_goi.gia_tri"
                controls-position="right"
                :min="1"
                class="w-100"
                placeholder="Nhập giá trị chu kỳ gói"
                v-model="mData.dataForm.chu_ky_goi.gia_tri"
              ></el-input-number>
            </el-form-item>
          </div>
          <el-form-item
            label="Công khai"
            class="d-flex"
            v-if="mData.viewMode !== 'detail'"
          >
            <el-checkbox
              ref="cong_khai"
              :disabled="mData.viewMode === 'detail'"
              v-model="mData.dataForm.cong_khai"
              >Công khai gói dịch vụ</el-checkbox
            >
          </el-form-item>

          <div
            class="detail-prd"
            style="margin: 10px 0"
            v-if="mData.viewMode === 'detail'"
          >
            <p>
              Chu kỳ gói: {{ this.mData.dataForm.chu_ky_goi.gia_tri }}
              {{
                this.mData.dataForm.chu_ky_goi.loai === "nam"
                  ? "năm"
                  : this.mData.dataForm.chu_ky_goi.loai === "quy"
                  ? "quý"
                  : "tháng"
              }}
            </p>
            <span
              class="detail-prd__status detail-prd__status--show"
              v-if="this.mData.dataForm.cong_khai"
              >Công khai</span
            >
            <span class="detail-prd__status detail-prd__status--hide" v-else
              >Ẩn gói dịch vụ</span
            >
          </div>
          <div v-if="mData.viewMode === 'detail'">
            <el-table
              :data="mData.listChucNang"
              style="width: 100%"
              cell-class-name="cell-table"
            >
              <el-table-column label="DANH SÁCH CHỨC NĂNG" width="120">
                <el-table-column
                  prop="ten"
                  label="Tên chức năng"
                  min-width="120"
                  align="left"
                />

                <el-table-column
                  prop="ma"
                  label="Mã"
                  min-width="120"
                  align="left"
                >
                </el-table-column>
                <el-table-column
                  prop="gia_tri_full"
                  label="Giá trị"
                  width="200"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      v-if="
                        scope.row.gia_tri_full === 1 &&
                        scope.row.kieu_du_lieu === 'boolean'
                      "
                      style="color: #67c23a"
                      class="fa-solid fa-circle-check"
                    ></i>
                    <i
                      v-if="
                        scope.row.gia_tri_full === 0 &&
                        scope.row.kieu_du_lieu === 'boolean'
                      "
                      style="color: #f56c6c"
                      class="fa-solid fa-circle-xmark"
                    ></i>
                    <span v-if="scope.row.kieu_du_lieu !== 'boolean'">{{
                      scope.row.gia_tri_full
                    }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="mData.viewMode !== 'detail'">
            <el-table
              :data="mData.listChucNangAll"
              style="width: 100%"
              ref="multipleTable"
              @selection-change="handleSelection"
            >
              <el-table-column
                label="DANH SÁCH CHỨC NĂNG"
                width="120"
                align="center"
              >
                <el-table-column type="selection" width="55" align="center" />
                <el-table-column
                  prop="ma"
                  label="Mã"
                  min-width="120"
                  align="left"
                />
                <el-table-column
                  prop="ten"
                  label="Tên chức năng"
                  min-width="120"
                  align="left"
                />
                <el-table-column
                  prop="gia_tri"
                  label="Giá trị"
                  width="200"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input-number
                      controls-position="right"
                      v-model="scope.row.gia_tri"
                    ></el-input-number
                  ></template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
          <div class="text-center mt-3">
            <el-button type="default" @click="fn_back()" v-ladda
              >quay lại</el-button
            >
            <el-button
              type="primary"
              @click="fn_actionGoiDichVu('create')"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_actionGoiDichVu('update')"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "@/service/ValidService";
import MethodService from "@/service/MethodService";
import LanguageService from "@/service/LanguageService";
import DataForm from "@/dataForm/dataFormGoiDichVu";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Circle4,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      ten_dong_ho: [],
      imageSpin: false,
      loading: true,
      multipleSelection: [],
      multipleSelectionUpdate: [],
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        chuKyGoi: MethodService.copyObject(DataForm.chu_ky_goi),
        validForm: {
          ten: [
            ValidService.required,
            ValidService.checkSpaceString,
            ValidService.checkMinLength(1),
          ],
          ma: [ValidService.required, ValidService.checkCode],
          chu_ky_goi: {
            loai: [ValidService.required],
            gia_tri: [ValidService.requiredBlur],
          },
        },
        listChucNang: [], // danh sách chức năng cho bảng hiển thị
        listChucNangAll: [], // danh sách chức năng theo pms_chuc_nang
      },
    };
  },
  methods: {
    trimString() {
      if (!this.mData.dataForm.ten) return;
      this.mData.dataForm.ten = this.mData.dataForm.ten
        .trim()
        .replaceAll(/\s+/g, " ");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val && val.length > 0) {
        this.mData.dataForm.danh_sach_chuc_nang = [];
        val.forEach((item) => {
          this.mData.dataForm.danh_sach_chuc_nang.push({
            ma: item.ma,
            ten: item.ten,
            gia_tri: item.gia_tri,
          });
        });
      }
    },
    handleSelection(val) {
      this.multipleSelectionUpdate = val;
      this.multipleSelection = val;
      if (val && val.length > 0) {
        this.mData.dataForm.danh_sach_chuc_nang = val;
      }
    },
    async fn_getChucNang() {
      const response = await mushroom.pms_chuc_nang.getAllAsync({
        limit: 100,
        sort: "thu_tu",
      });
      if (response.result && response.result.length > 0) {
        response.result.forEach((item) => (item.gia_tri = ""));
      }
      this.mData.listChucNangAll = response.result;
    },
    async fn_initForm() {
      try {
        const response = await mushroom.prd_goi_dich_vu.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields:
            "id,thu_tu,ten,ma,chu_ky_goi,danh_sach_chuc_nang,cong_khai,thoi_diem_cap_nhat",
        });
        const res = await this.fn_changeData(response.result);
        this.mData.dataForm = res;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      } finally {
        this.loading = false;
      }
    },
    async fn_changeData(data) {
      let list_ma_chuc_nang = data.danh_sach_chuc_nang.map((x) => x.ma);

      const resChucNang = await mushroom.pms_chuc_nang.listAsync({
        filters: ["ma:in:" + list_ma_chuc_nang],
        fields:
          "id,ma,ten,thu_tu,tuy_bien_hien_thi,kieu_du_lieu,nhom,don_vi,hien_thi",
        sort: "thu_tu",
      });

      this.mData.listChucNang = [];
      data.danh_sach_chuc_nang.forEach((item) => {
        if (resChucNang.result && resChucNang.result.length > 0) {
          resChucNang.result.forEach((chuc_nang) => {
            if (item.ma === chuc_nang.ma) {
              this.mData.listChucNang.push({
                gia_tri_full: "",
                gia_tri: item.gia_tri,
                ma: item.ma,
                ten: item.ten,
                kieu_du_lieu: chuc_nang.kieu_du_lieu,
                thu_tu: chuc_nang.thu_tu,
                don_vi: chuc_nang.don_vi,
                tuy_bien_hien_thi: chuc_nang.tuy_bien_hien_thi || undefined,
              });
            }
          });
        }
      });
      let arrayIndex = [];
      let arrayGoiDichVu = [];
      this.mData.listChucNang.forEach((item) => {
        if (item.tuy_bien_hien_thi && item.tuy_bien_hien_thi.length > 0) {
          item.tuy_bien_hien_thi.forEach((x) => {
            if (item.gia_tri === x.gia_tri) {
              item.gia_tri_full = x.gia_tri_hien_thi;
            } else item.gia_tri_full = item.gia_tri + " " + item.don_vi;
          });
        } else if (!item.tuy_bien_hien_thi && item.don_vi) {
          item.gia_tri_full = item.gia_tri + " " + item.don_vi;
        } else item.gia_tri_full = item.gia_tri;
        if (this.mData.viewMode === "update") {
          arrayGoiDichVu = [];
          this.mData.listChucNangAll.forEach((chuc_nang_all, index) => {
            if (chuc_nang_all.ma === item.ma) {
              chuc_nang_all.gia_tri = item.gia_tri;
              arrayIndex.push(index);
            }
          });
        }
      });

      arrayIndex.forEach((index) => {
        arrayGoiDichVu.push(this.mData.listChucNangAll[index]);
      });
      this.toggleSelection(arrayGoiDichVu);
      return data;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    async fn_actionGoiDichVu(type) {
      this.$refs["myForm"].validate(async (valid, objectError) => {
        if (valid) {
          try {
            if (type === "create") {
              if (this.multipleSelection.length === 0) {
                window.toastr.warning("Chọn ít nhất 1 chức năng");
                MethodService.stopLadda();
                return false;
              } else {
                const newId = await mushroom.prd_goi_dich_vu.createAsync(
                  this.mData.dataForm
                );
                if (newId) {
                  window.toastr.success("Thêm mới gói dịch vụ thành công");
                  this.$router.go(-1);
                }
              }
            }
            if (type === "update") {
              if (this.multipleSelectionUpdate.length === 0) {
                window.toastr.warning("Chọn ít nhất 1 chức năng");
                MethodService.stopLadda();
                return false;
              } else {
                this.mData.dataForm.danh_sach_chuc_nang =
                  this.multipleSelectionUpdate;
                const resUpdate =
                  await mushroom.prd_goi_dich_vu.partialUpdateAsync(
                    this.mData.dataForm
                  );
                if (resUpdate.result === this.mData.dataForm.id) {
                  window.toastr.success("Cập nhật gói dịch vụ thành công");
                } else window.toastr.warning("Dữ liệu không thay đổi");
              }
            }
          } catch (e) {
            MethodService.showError(e.code);
          } finally {
            MethodService.stopLadda();
          }
        } else {
          let arrKey = Object.keys(objectError);
          if (arrKey.length > 0) {
            this.$refs[arrKey[0]].$el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            setTimeout(() => {
              this.$refs[arrKey[0]].focus();
            }, 500);
          }

          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_back() {
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  async created() {
    // kiểm tra loại viewMode
    if (this.$router.currentRoute.name == "ThemMoiGoiDichVu") {
      this.mData.viewMode = "create";
      await this.fn_getChucNang();
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietGoiDichVu") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatGoiDichVu") {
      this.mData.viewMode = "update";
      await this.fn_getChucNang();
      await this.fn_initForm();
    }
  },
};
</script>
<style scoped lang="scss">
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  &__name {
    span {
      color: #f56c6c;
      text-transform: uppercase;
    }
  }
}
::v-deep.card-body {
  label.el-form-item__label,
  label.el-checkbox {
    margin-bottom: 0 !important;
  }
}
.cell-table {
  .cell {
    line-height: 100%;
  }
}
::v-deep.el-table th.el-table__cell > .cell {
  padding-left: 10px !important;
}
::v-deep.el-table--border .el-table__cell:first-child .cell {
  padding-left: 14px;
}
::v-deep.form-prd-goi-dich-vu {
  .el-form-item__content {
    width: calc(100% - 150px);
    margin-left: 0 !important;
  }
}
</style>
